import mixpanel from "mixpanel-browser";
import { config } from "../../config";

mixpanel.init(config.mixpanel.token as string, {
  debug: !config.inProd,
  ignore_dnt: !config.inProd,
});

export const Mixpanel = {
  instance: mixpanel,
  identify(id: string) {
    if (config.inProd) mixpanel.identify(id);
  },
  track(name: string, props: any) {
    if (config.inProd) mixpanel.track(name, props);
  },
  getDistinctId() {
    if (config.inProd) return mixpanel.get_distinct_id();
  },
};
